var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('compute.text_112')}}),_c('page-body',[_c('physicalmachine-list',{attrs:{"getParams":_vm.getParams,"id":_vm.listId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }